import { Box, Grid, Skeleton, Typography } from '@mui/material';
import { useStyles } from '../../styles';
import { useTranslation } from 'react-i18next';
import { Week } from '../../settings.types';
import { LANG_TEXT } from '../../../../constants/language';

const Loader: React.FC<{ rows?: number }> = ({ rows }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.Content}>
      <Box className={classes.OperatingHourSettings}>
        <Box className={classes.OperatingHourSettingsTitle}>
          <Typography fontSize={16} fontWeight={500} lineHeight={'24px'}>
            {t(LANG_TEXT.OPERATING_HOUR_SETTINGS)}
          </Typography>
        </Box>
        <Box className={classes.OperatingHourSettingsContent}>
          <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }} justifyContent="center" alignItems="center">
            {Week.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <Box className={classes.BoxCard}>
                  <Skeleton sx={{ borderRadius: '8px' }} variant="rectangular" width={55} height={40} />
                  <Skeleton className={classes.SkeletonBoxContent} variant="rectangular" width={'100%'} height={47} />
                  <Skeleton className={classes.SkeletonBoxContent} variant="rectangular" width={'100%'} height={47} />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
      <Box className={classes.BoxButtonLoader}>
        <Skeleton variant="rectangular" width={100} height={47} />
      </Box>
    </Box>
  );
};

export default Loader;
